import axios from 'axios';

const baseUrl = '/jobs';

export default {
  getJobs() {
    return axios.get(`${baseUrl}/`);
  },
  createJob(payload) {
    return axios.post(`${baseUrl}/create`, payload);
  },
};
